// extracted by mini-css-extract-plugin
export default {"flipContainer":"Flip_flipContainer__b6EuN","flipped":"Flip_flipped__edrRr","flipper":"Flip_flipper__GwRCA","front":"Flip_front__1B-iy","back":"Flip_back__6pWUe"};